import React from 'react'
import styled from 'styled-components'

const LineWithText = styled.div({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  margin: '16px 0',

  '&&::before': {
    content: '""',
    flex: 1,
    borderBottom: '1px solid #ccc',
    marginRight: 10
  },

  '&&::after': {
    content: '""',
    flex: 1,
    borderBottom: '1px solid #ccc',
    marginLeft: 10
  },

  '& span': {
    fontFamily: 'Proxima-Nova',
    color: '#636363',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '115%'
  }
})

const SeparationLine = ({ text }) => {
  return (
    <LineWithText>
      <span>{text}</span>
    </LineWithText>
  )
}

export default SeparationLine
